






import Vue from "vue"
import Datatable, {DatatableOptions} from "@/components/datatable/Datatable.vue"
import {ParcelShop} from "@/model/entity/parcel-shop/parcel-shop"
import {IParcelShopService, parcelShopService} from "@/model/service/parcel-shop/parcel-shop-service"
import {FieldDescription} from "@/model/entity/field-descriptor"

interface Data {
  parcelShopService: IParcelShopService
  options: DatatableOptions
  fields: FieldDescription[]
}

export default Vue.extend({
  components: {Datatable},
  data(): Data {
    return {
      parcelShopService: parcelShopService,
      options: {},
      fields: ParcelShop.getFieldDescriptionList()
    }
  }
})
